package pl.decks.personal.components.widgets.timeline

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier


@Composable
fun RangeTimeline(
    range: YearMonth.Range,
    isShowingYearLabel: Boolean = true,
    yearLabelAlignment: Alignment = Alignment.TopCenter,
    monthRenderer: MonthRenderer = MonthRenderer.default,
    modifier: Modifier = Modifier,
) = Column(modifier) {
    RangeTimelineYearLabel(range.from.year, isShowingYearLabel, yearLabelAlignment)
    RangeTimelineMonthlyMarkers(range, monthMarkerRenderer = monthRenderer.marker)
    RangeTimelineMonthLabels(range, monthLabelRenderer = monthRenderer.label)
}


@Composable
private fun RangeTimelineYearLabel(
    year: Int,
    isShowing: Boolean,
    alignment: Alignment,
) = Box(
    modifier = MonthlyTimelineStylesheet.YearLabelContainer.toModifier(),
    contentAlignment = alignment,
) {
    Box {
        if (isShowing) SpanText(year.toString(), modifier = MonthlyTimelineStylesheet.YearLabel.toModifier())
    }
}

@Composable
private fun RangeTimelineMonthlyMarkers(
    range: YearMonth.Range,
    monthMarkerRenderer: @Composable (YearMonth) -> Unit,
) = Row(MonthlyTimelineStylesheet.TimelineContainer.toModifier()) {
    range.forEach { ym ->
        Box(
            modifier = Modifier.weight(1f).fillMaxWidth().fillMaxHeight().weight(1f),
            contentAlignment = Alignment.Center,
        ) {
            monthMarkerRenderer(ym)
        }
    }
}


@Composable
private fun RangeTimelineMonthLabels(
    range: YearMonth.Range,
    monthLabelRenderer: @Composable (YearMonth) -> Unit,
) = Row(MonthlyTimelineStylesheet.MonthLabelsContainer.toModifier()) {
    range.forEach { ym ->
        Box(
            modifier = Modifier.weight(1f).fillMaxWidth().fillMaxHeight(),
            contentAlignment = Alignment.Center,
        ) {
            monthLabelRenderer(ym)
        }
    }
}
